module.exports = __webpack_public_path__ + "fonts/SFUIText-Semibold.fa9d5adb.ttf";